import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import styles from './page-title.module.css';
import { PageTitleHeader } from '../../typescript/component';
import { Breadcrumbs } from './breadcrumbs';

export default function PageTitle({ page_title }: { page_title: PageTitleHeader }) {
  const { asPath } = useRouter();
  const pathnames = asPath.split('/').filter(x => x);

  return (
    <>
      <div className={styles.innerWrapper}>
        <Breadcrumbs pathnames={pathnames} title={page_title.title} key={pathnames.join('/')} />

        <div className={styles.containerHeroTitle}>
          <h1 className={styles.title} style={{ fontSize: page_title.titleFontSize }}>
            {page_title.title}
          </h1>
          {page_title.description && (
            <div
              className={styles.description}
              dangerouslySetInnerHTML={{ __html: page_title.description }}
            />
          )}
        </div>
      </div>
      {!page_title.hideBorder && <div className={styles.border}></div>}
    </>
  );
}
